import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-black text-zinc-500 flex items-center justify-center font-mono text-sm" data-testid="auth-loading">
        Yüklənir...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
